import { stats } from '@/mocks/homeData';

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-foreground-400 text-xs font-medium tracking-wider uppercase">
            数据说话
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mt-3">
            值得信赖的
            <br />
            <span className="italic text-accent-500">韩漫平台</span>
          </h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg mx-auto">
            我们用数据来证明，为什么数百万人选择我们
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="rounded-2xl bg-accent-500 p-8 md:p-10 flex flex-col justify-between min-h-[240px] relative overflow-hidden">
            <div className="relative z-10">
              <span className="text-5xl md:text-6xl font-heading font-bold text-background-50">
                {stats.satisfaction}
              </span>
              <p className="text-background-50/80 text-sm mt-3">读者满意度</p>
              <p className="text-background-50/60 text-xs mt-1">基于超过50万用户的真实评价</p>
            </div>
            <p className="text-background-50/90 text-sm italic mt-6 relative z-10">
              用心做好每一部韩漫
            </p>
            <div className="absolute top-6 right-6 z-10">
              <span className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center cursor-pointer">
                <i className="ri-arrow-right-up-line text-background-50"></i>
              </span>
            </div>
          </div>

          <div className="rounded-2xl bg-secondary-500 p-8 md:p-10 flex flex-col justify-between min-h-[240px] relative overflow-hidden">
            <div className="relative z-10">
              <span className="text-5xl md:text-6xl font-heading font-bold text-background-50">
                {stats.dailyReaders}
              </span>
              <p className="text-background-50/80 text-sm mt-3">每日活跃读者</p>
              <p className="text-background-50/60 text-xs mt-1">
                涵盖恋爱、奇幻、动作、悬疑等全品类题材
              </p>
            </div>
            <p className="text-background-50/90 text-sm italic mt-6 relative z-10">
              每天都有新发现
            </p>
            <div className="absolute top-6 right-6 z-10">
              <span className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center cursor-pointer">
                <i className="ri-arrow-right-up-line text-background-50"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}